import {
  SET_ALBUMS,
  DELETE_ALBUM,
  LIKE_ALBUM,
  UNLIKE_ALBUM
} from "@/store/mutation-types";

export default {
  [SET_ALBUMS](state, albums) {
    state.albums = {
      ...state.albums,
      ...albums.reduce((map, album) => ({ ...map, [album.id]: album }), {})
    };
  },
  [LIKE_ALBUM](state, id) {
    state.albums[id].likes.liked = true;
    state.albums[id].likes.count += 1;
  },
  [UNLIKE_ALBUM](state, id) {
    state.albums[id].likes.liked = false;
    state.albums[id].likes.count -= 1;

    if (state.albums[id].likes.count < 0) {
      state.albums[id].likes.count = 0;
    }
  },
  [DELETE_ALBUM](state, albumId) {
    if (state.albums[albumId]) {
      delete state.albums[albumId];
    }

    state.albums = { ...state.albums };
  }
};
